<script lang="ts">
  import { EmptyLabelDefault } from '$provider/constants/global';

  import { parseDynamicData } from '$shared/helpers/utils';
  import { toHeaderCase } from 'js-convert-case';
  interface Props {
    value?: ObjectType<string>;
  }

  let { value = {} }: Props = $props();
</script>

<div class="comp-object-list-type">
  {#each Object.entries(value) as [key, value]}
    <div class="object-i">
      <div data-cy={`${key}-k`} class="key">{toHeaderCase(key)}</div>
      <div data-cy={`${key}-v`} class="value">{parseDynamicData(value)}</div>
    </div>
  {:else}
    {EmptyLabelDefault}
  {/each}
</div>

<style>
  .comp-object-list-type {
    width: 100%;
  }
  .object-i {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
  }
</style>
